import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { createStyles, Theme, withStyles, WithStyles } from "@material-ui/core/styles";
import React from "react";
import { WidgetProps } from "./models";

const styles = (theme: Theme) =>
  createStyles({
    label: {
      marginTop: theme.spacing(2),
    },
  });

interface CheckboxWidgetProps extends WidgetProps<boolean>, WithStyles<typeof styles> {}

export const CheckboxWidgetComponent = (props: CheckboxWidgetProps) => {
  const { id, value, label, disabled, classes, onChange, onBlur, onFocus } = props;

  const handleChange = (event: any) => onChange(event.target.checked as boolean);
  const handleBlur = onBlur && ((event: any) => onBlur(id, value));
  const handleFocus = onFocus && ((event: any) => onFocus(id, value));

  return (
    <FormControlLabel
      control={
        <Checkbox
          id={id}
          checked={!!value}
          disabled={disabled}
          onChange={handleChange}
          onBlur={handleBlur}
          onFocus={handleFocus}
        />
      }
      label={label}
      classes={{ root: classes.label }}
    />
  );
};

export const CheckboxWidget = withStyles(styles)(CheckboxWidgetComponent);
